import { SortingTypeEnum } from '../enums/sorting-type.enum';

export class SortingTypeModel {
    name = 'First Name Last Name [A - Z]';
    value = SortingTypeEnum.displayName;
    order = 1;
    fallback?: any[] = [];
    fallbackKey = SortingTypeEnum.displayName;
}
